import type { TrackDef } from '../track';
import { autoGates } from './util';

/**
 * Autodromo Lombardia: tribute to round 3, Monza (design.md A5.3).
 * Long flat-out straights, a chicane at the end of the start straight,
 * a long right-hand run, the twisty back section and the big left-hand
 * Parabolica-style loop onto the main straight. Grass run-off.
 */
const centerline: [number, number][] = [
  [9, 1.3], [44, 1.3], [46.5, 0.2], [49, 2.4], [52, 1.5], [60, 1.5], [63, 3], [66, 5],
  [66, 24], [67.5, 26], [68, 30], [68, 37], [66, 38.5], [55, 38.5], [52, 37], [52, 33],
  [50, 30], [48, 27.5], [46, 25.5], [44.5, 23], [42, 21], [40, 19], [37, 17], [33, 15.5],
  [24, 14], [8, 13.8], [4.5, 12.5], [2.5, 10], [2.5, 7], [4, 5], [6, 3.5],
];

export const LOMBARDIA: TrackDef = {
  id: 'lombardia',
  name: 'AUTODROMO LOMBARDIA',
  subtitle: 'Tribute to Monza, Milan',
  country: 'ITALY',
  theme: 'park',
  scale: 48.3,
  offset: [5, 5],
  centerline,
  roadWidth: 76,
  kerbWidth: 6,
  runoffWidth: 26,
  runoffSurface: 'grass',
  gates: autoGates(centerline, 0, 0.5, 6),
  carparks: [],
  raceLaps: 3,
  defaultRecord: 29.5,
};
